import { AnchorButton, Button } from "@blueprintjs/core";
import React, { useRef } from "react";
import "styled-components/macro";
import { message, Tooltip } from "antd";
import { useHideForm } from "../../store/model-misc";
import { useStoreActions } from "../../hooks/ep";
import { useSubmissionMessage } from "./use-submission-message";
import { useRaPayload2 } from "./modal-or-drawer";
import { useBoolean } from "../../helpers/useBoolean";

export function FormBase({ children, formState, formActions }) {
  const { opportunityData, actionName } = useRaPayload2();
  const handleClose = useHideForm();
  const isSubmitted = useRef(false);
  const handleSubmitActionReport = useStoreActions(
    (a) => a.actionReports.handleSubmitActionReport
  );
  const constructActionReport = (formData) => ({
    action: actionName,
    snapshot: opportunityData,
    payload: formData,
  });
  const submissionMessage = useSubmissionMessage(actionName);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    if (!formState.dataIsSubmittable) {
      message.error("Please fill out all form fields before submitting");
    } else if (isSubmitted.current) {
      // No double-submissions!
      console.error("Already submited");
    } else {
      const actionReport = constructActionReport(formState.formData);
      try {
        isSubmitted.current = true;
        await handleSubmitActionReport(actionReport);
        message.success(submissionMessage);
        handleClose();
      } catch (err) {
        isSubmitted.current = false;
        message.destroy();
        message.error("Failed to submit. Please try again.");
      }
    }
  };

  const readyToSubmit = !formState.errorMessage;
  const notReadyToSubmit = !readyToSubmit;
  console.log({
    notReadyToSubmit,
    "formState.errorMessage": formState.errorMessage,
  });

  return (
    <form
      onSubmit={onSubmit}
      css={`
        width: 100%;
        //height: 100%;
        //min-height: 500px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        & > * {
          margin-bottom: 48px !important;
        }
        & > *:last-child {
          margin-bottom: unset !important;
        }
      `}
    >
      {children}
      <Tooltip
        placement="bottom"
        title={
          formState.errorMessage && (
            <span data-testid="report_action_form__submit_button_tooltip_title">
              {formState.errorMessage}
            </span>
          )
        }
        mouseEnterDelay={0.1}
        mouseLeaveDelay={0.1}
      >
        <span>
          <Button
            fill
            type="submit"
            intent="primary"
            data-testid="report_action_form__submit_button"
            disabled={notReadyToSubmit || isSubmitted.current}
          >
            Submit
          </Button>
        </span>
      </Tooltip>
    </form>
  );
}
